import { Routes } from '@angular/router';
import { PermissionsList } from '../../shared/common/PermissionList';
import { AuthorizationGuard } from '../../core/auth/guards/authorization.guard';


export const ProfileRoutes: Routes = [
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfilePageComponent),
    title: 'Profile | ADROIT',
    data: {
      animation: 'home',
      PermissionPageName: [PermissionsList[PermissionsList.ClientPlacesView]],
    },
    canActivate: [AuthorizationGuard],
  },
];
